"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MartianMonuments = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Resources_1 = require("../../Resources");
var Tags_1 = require("../Tags");
var CardRequirements_1 = require("../CardRequirements");
var Options_1 = require("../Options");
var MartianMonuments = (function (_super) {
    __extends(MartianMonuments, _super);
    function MartianMonuments() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MARTIAN_MONUMENTS,
            cost: 5,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.MARS],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.cities(); }),
            metadata: {
                cardNumber: 'Pf09',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production((function (pb) { return pb.megacredits(1); })).slash().mars(1, { played: Options_1.played });
                }),
                description: 'Requires that you own a city on Mars. Raise your M€ production 1 step for every Mars tag you own (including this.)',
            },
        }) || this;
    }
    MartianMonuments.prototype.play = function (player) {
        var count = player.getTagCount(Tags_1.Tags.MARS) + 1;
        player.addProduction(Resources_1.Resources.MEGACREDITS, count, { log: true });
        return undefined;
    };
    return MartianMonuments;
}(Card_1.Card));
exports.MartianMonuments = MartianMonuments;
